import {Validators} from "@angular/forms";
import {PasswordStrength} from "./services/a-b.service";

const strictPasswordValidator = Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/);
const relaxedPasswordValidator = Validators.minLength(6);

const strictPasswordValidationErrorMessage = 'Your password needs to be at least 8 characters including a lower-case letter, an upper-case letter, a number and one special character (!@#$%^&*)';
const relaxedPasswordValidationErrorMessage = 'Your password needs to be at least 6 characters';

// Validators.email accepts a domain with no dot (name@gmail), which Stripe rejects once the user
// tries to start a trial. The pattern only adds the dot; Validators.email checks the rest.
export const emailValidators = [Validators.email, Validators.pattern(/@[^@]*\.[^@.]+$/)];

export const emailValidationErrorMessage = {
  email: 'Please enter a valid email address',
  pattern: 'Please check the part after the @, e.g. name@gmail.com',
};

export function getPasswordValidator(strength: PasswordStrength) {
  return strength === 'relaxed' ? relaxedPasswordValidator : strictPasswordValidator;
}

export function getPasswordValidationErrorMessage(strength: PasswordStrength) {
  return strength === 'relaxed' ? relaxedPasswordValidationErrorMessage : strictPasswordValidationErrorMessage;
}
